import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import usePopup from "../../hooks/usePopup";
import { useMutation } from "react-query";
import { useEffect } from "react";
import {
  Button,
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import { ArrowBack, Close, Save } from "@mui/icons-material";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { formDataType, UserListType } from "./types";

import {  user } from "../../constants";
import {
  getAllClincs,
  getAllemployees,
  getUserGroups,
  saveUSer,
} from "./service";
import { FormOnChangeEventType } from "../../EMR/types";
import { getItem, storageKey } from "@utilifiles/methods/storage/storage";

function EditUserPage() {
  const pageTitle = "User";
   const clinicianId = parseInt(getItem(storageKey.clinicianID) || "0");
       const clinicId = parseInt(getItem(storageKey.clinicId) || "0");
  console.log("userrrrrrrrr:::::",user) 
  console.log("clinicianId:::::",clinicianId)
  const navigate = useNavigate();
  
  console.log("userrrrrrrrr:::::",user) 
  console.log("clinicianId:::::",clinicianId) 
  const { control, handleSubmit, reset, setValue, setError, getValues } =
    useForm<formDataType>();
  const {
    state: { data = null },
  } = useLocation() as { state: { data: UserListType } };
  const { showSnackbar } = usePopup();

  const handleGoBack = () => {
    navigate(-1);
  };
  console.log(data,"dataaaaa")

  const { mutate: editUser, isLoading } = useMutation(saveUSer, {
    onSuccess: (result) => {
      if (result.responseIndicator === "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong!",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });

  const { data: clinicList, mutate: getclinicsList } = useMutation(
    getAllClincs,
    {
      onSuccess: () => {
        if (data?.clinicName != null) {
          setValue("clinicName", {
            clinicName: data?.clinicName as string,
            clinicId: data?.clinicId as number,
            domainName: data?.domainName,
          });
          setValue("domainName", data?.domainName as string);
        }
      },
    }
  );
  const { data: employeeList, mutate: getEmployees } = useMutation(
    getAllemployees,
    {
      onSuccess: () => {
        if (data?.empId != null) {
          setValue("empName", {
            empId: data?.empId as number,
            empName: data?.empName as string,
          });
        }
      },
    }
  );
  const { data: userGroupList, mutate: getUserGroupList } = useMutation(
    getUserGroups,
    {
      onSuccess: () => {
        if (data?.userGroupId != null) {
          setValue("userGroupName", {
            userId: data?.userGroupId as number,
            userName: data?.userGroupName,
          });
        }
      },
    }
  );

  const onSubmit = (value: formDataType) => {
     console.log("Submit clicked:", value);
    if (value?.password !== value?.confirmPassword) {
      setError("confirmPassword", { message: "" });
      return;
    }

    editUser([
      {
        clinicId: value.clinicName?.clinicId as number,
        id: data?.id || null,
        empId: value.empName?.empId as number,
        username: value.username,
        // domainName: value.domainName,
        password: value.password,
        userGroupId: value.userGroupName?.userId as number,
        status: value?.status,
        createdById: data?.createdById || 0,
        // createdDate:
        //   data?.createdDate || moment().format("YYYY-MM-DD HH:mm:ss"),
        ip: "",
        empName: value?.empName?.empName as string,
        // userGroupName: (value?.userGroupName?.userName as string) || "",
        // clinicName: value?.clinicName?.clinicName as string,
        clinicianId:clinicianId
      }
    ]);
  };

  const clinicChange = (e: FormOnChangeEventType) => {
    const value = e.target?.value;
    reset({
      ...getValues(),
      empName: null,
      username: "",
      password: "",
      status: 1,
      userGroupName: null,
      confirmPassword: "",
      domainName: "",
    });
    if (value?.domainName != null) {
      setValue("domainName", value.domainName);
    } else {
      setValue("domainName", "");
    }
  };

  useEffect(() => {
    const initialsearchbody = { searchText: "", clinicId };
    getclinicsList(initialsearchbody);
    getEmployees(initialsearchbody);
    getUserGroupList();
    console.log("data", data);
    if (data) {
      reset({
        username: data.username || "",
        password: "",
        confirmPassword: "",
        status: data?.status,
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit, (errors) => console.log("Validation errors:", errors))}>

        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data?.username ? "Edit" : "ADD"} {pageTitle}{" "}
                {data?.username ? `- ${data?.username}` : ""}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outlined"
                startIcon={<ArrowBack />}
                onClick={handleGoBack}
              >
                Back
              </Button>
              <Button
                disabled={isLoading}
                color="error"
                onClick={() =>
                  reset({
                    clinicName: null,
                    empName: null,
                    username: "",
                    password: "",
                    status: 1,
                    userGroupName: null,
                    confirmPassword: "",
                    domainName: "",
                  })
                }
                startIcon={<Close />}
              >
                Reset
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                color={data != null ? "primary" : "success"}
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="primary" />
                  ) : (
                    <Save />
                  )
                }
              >
                {data != null ? "Update" : "Save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-2 gap-3">
            <CustomFormField
              control={control}
              name="clinicName"
              element="autocomplete"
              options={clinicList?.response ?? []}
              fieldProps={{ label: "Choose Clinic" }}
              rules={{ required: "Clinic is required", onChange: clinicChange }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) =>
                  option.clinicId === value.clinicId,
                getOptionLabel: (option) => option.clinicName,
              }}
            />
            <CustomFormField
              control={control}
              name="empName"
              element="autocomplete"
              options={employeeList?.response ?? []}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) =>
                  option.empId === value.empId,
                getOptionLabel: (option) => option.empName,
              }}
              fieldProps={{ label: "Choose Employee" }}
              rules={{ required: "Employee is required" }}
            />
            <CustomFormField
              control={control}
              name="username"
              element="input"
              fieldProps={{ label: "Enter Username",type:"email" }}
              rules={{ required: "Username is required" }}
            />
            <div className="hidden">
              <CustomFormField
                control={control}
                name="domainName"
                element="input"
                fieldProps={{ label: "Enter Domain Name" }}
                rules={{ required: false }}
              />
            </div>
            <CustomFormField
              control={control}
              name="password"
              element="input"
              fieldProps={{
                label: "Enter Password",
                type: "password",
                autoComplete: "new-password",
              }}
              rules={{ required: "Password is required" }}
            />
            <CustomFormField
              control={control}
              name="confirmPassword"
              element="input"
              fieldProps={{ label: "Confirm Password", type: "password" }}
              rules={{ required: "Password is required" }}
            />
            <CustomFormField
              control={control}
              name="userGroupName"
              element="autocomplete"
              fieldProps={{ label: "Choose UserGroup" }}
              rules={{ required: "UserGroup is required" }}
              options={userGroupList?.response ?? []}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) =>
                  option.userId === value.userId,
                getOptionLabel: (option) => option.userName,
              }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default EditUserPage;
